import { jsx as _jsx } from "react/jsx-runtime";
import { Swap } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { useSysadmin } from "./SysadminProvider";
export const SysadminClearWorkspaceButton = /*#__PURE__*/ memo(()=>{
    const { handleClearWorkspaceId, isInternal } = useSysadmin();
    if (!isInternal) return null;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "bg-black text-white hover:bg-black hover:text-white active:bg-black active:text-white",
        color: "grey",
        onClick: handleClearWorkspaceId,
        icon: Swap,
        label: "Switch"
    });
});
SysadminClearWorkspaceButton.displayName = "SysadminClearWorkspaceButton";
